import { Link } from 'react-router-dom';
import styled from 'styled-components';

export default styled(Link)`
  color: inherit;
  cursor: pointer;
  text-decoration: none;

  :hover,
  :visited {
    text-decoration: none;
  }
`;
